import { HEADER_POSITION_TYPE } from '@/scripts/constants/header'

export const UPDATE_BACKGROUND = 'UPDATE_BACKGROUND'
export const UPDATE_MENU_ID = 'UPDATE_MENU_ID'
export const RESET_MENU_ID = 'RESET_MENU_ID'
export const SET_HEADER_STATIC_POSITION = 'SET_HEADER_STATIC_POSITION'
export const SET_HEADER_FIXED_POSITION = 'SET_HEADER_FIXED_POSITION'
export const SET_KEYBOARD_NAVIGATION = 'SET_KEYBOARD_NAVIGATION'
export const RESET_KEYBOARD_NAVIGATION = 'RESET_KEYBOARD_NAVIGATION'
export const SHOW_ACCOUNT_BULLET = 'SHOW_ACCOUNT_BULLET'
export const HIDE_ACCOUNT_BULLET = 'HIDE_ACCOUNT_BULLET'
export const UPDATE_HEADER_IS_COLLAPSED = 'UPDATE_HEADER_IS_COLLAPSED'

export const mutations = {
  [UPDATE_BACKGROUND]: function (state, payload) {
    state.isInBackground = payload
  },
  [UPDATE_MENU_ID]: function (state, payload) {
    state.currentMenuId = payload
  },
  [RESET_MENU_ID]: function (state) {
    state.currentMenuId = null
  },
  [SET_HEADER_STATIC_POSITION]: function (state) {
    state.position = {
      type: HEADER_POSITION_TYPE.STATIC,
      height: null,
    }
  },
  [SET_HEADER_FIXED_POSITION]: function (state, { height }) {
    state.position = {
      type: HEADER_POSITION_TYPE.FIXED,
      height,
    }
  },
  [SET_KEYBOARD_NAVIGATION]: function (
    state,
    {
      currentId,
      focusedElementIsInsideMainMenu,
      focusedElementIsInsideSubmenu,
      focusedElementIsLastInsideSubmenu,
      menuIds,
    }
  ) {
    state.keyboardNavigation = {
      currentId,
      focusedElementIsInsideMainMenu,
      focusedElementIsInsideSubmenu,
      focusedElementIsLastInsideSubmenu,
      menuIds,
    }
  },
  [RESET_KEYBOARD_NAVIGATION]: function (state) {
    state.keyboardNavigation = {
      currentId: null,
      focusedElementIsInsideMainMenu: false,
      focusedElementIsInsideSubmenu: false,
      focusedElementIsLastInsideSubmenu: false,
      menuIds: [],
    }
  },
  [SHOW_ACCOUNT_BULLET]: function (state) {
    state.accountBulletIsVisible = true
  },
  [HIDE_ACCOUNT_BULLET]: function (state) {
    state.accountBulletIsVisible = false
  },
  [UPDATE_HEADER_IS_COLLAPSED]: function (state, payload) {
    state.isCollapsed = payload
  },
}
